// The spine of this page. Both schedule columns are rendered, validated and
// saved by the same code; the only thing that differs is what this config says.
// Adding a field here is the whole change - nothing in the table, the editor or
// the validator is allowed to know a section or a field by name.
//
// readKey  - what the device reports, and the only thing the table displays.
// writeKey - what the cloud asks the device for, and the only thing we POST.
//
// A field is one control the user sees. It names the raw keys it is built from,
// so a time is one control over two keys and a date is one control over three.
// Types: boolean | time | date | timestamp (read-only).
export const SCHEDULE_SECTIONS = [
  {
    key: "default",
    readKey: "currentDefaultSchedule",
    writeKey: "expectedDefaultSchedule",
    label: "Default Schedule",
    hint: "Runs every day, with no end date.",
    accent: "#2050FF",
    tint: "#EDF1FF",
    fields: [
      {
        name: "active",
        type: "boolean",
        label: "Schedule active",
        activeKey: "active",
      },
      {
        name: "on",
        type: "time",
        label: "ON time",
        hourKey: "on_hour",
        minuteKey: "on_minute",
      },
      {
        name: "off",
        type: "time",
        label: "OFF time",
        hourKey: "off_hour",
        minuteKey: "off_minute",
      },
      {
        name: "updated",
        type: "timestamp",
        label: "Updated",
        timestampKey: "timestamp",
      },
    ],
  },
  {
    key: "temp",
    readKey: "currentTempSchedule",
    writeKey: "expectedTempSchedule",
    label: "Temp Schedule",
    hint: "Overrides the default schedule for a date window.",
    accent: "#9A6700",
    tint: "#FFF7E6",
    fields: [
      {
        name: "active",
        type: "boolean",
        label: "Schedule active",
        activeKey: "active",
      },
      {
        name: "on",
        type: "time",
        label: "ON time",
        hourKey: "on_hour",
        minuteKey: "on_minute",
      },
      {
        name: "off",
        type: "time",
        label: "OFF time",
        hourKey: "off_hour",
        minuteKey: "off_minute",
      },
      {
        name: "start",
        type: "date",
        label: "Start date",
        dayKey: "start_day",
        monthKey: "start_month",
        yearKey: "start_year",
        minOffsetDays: 0,
        maxOffsetDays: 7,
      },
      {
        name: "end",
        type: "date",
        label: "End date",
        dayKey: "end_day",
        monthKey: "end_month",
        yearKey: "end_year",
        minOffsetDays: 0,
        maxOffsetDays: 7,
        after: {
          field: "start",
          inclusive: true,
          message: "Cannot be before the start date",
        },
      },
      {
        name: "updated",
        type: "timestamp",
        label: "Updated",
        timestampKey: "timestamp",
      },
    ],
  },
];

export const THEME = {
  ink: "#212529",
  muted: "#6C757D",
  line: "#E9ECEF",
  page: "#F6F8FD",
  surface: "#FFFFFF",
  band: "#F1F4FB",
  accent: "#2050FF",
  accentTint: "#EDF1FF",
  ok: "#1B7F4B",
  okTint: "#E6F6EC",
  warn: "#9A6700",
  warnTint: "#FFF7E6",
  radius: "10px",
  font: "manrope",
};
